/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {UrlBuilderService} from '@irian-ro/abstract-resource';
import {LazyLoadEvent} from 'primeng/api';
import {AvailabilityOptionsDTO} from './model/availability/availability-options-DTO.model';
import {ResourceAvailabilityDTO} from './model/availability/resource-availability-DTO.model';
import {Observable} from "rxjs/index";

@Injectable()
export class ResourceAvailabilityService {

  private baseUrl;

  constructor(private httpClient: HttpClient) {
    this.baseUrl = 'api/';
  }

  getResourcesAvailability(options: AvailabilityOptionsDTO, event: LazyLoadEvent): Observable<ResourceAvailabilityDTO[]> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient
      .post<ResourceAvailabilityDTO[]>(
        UrlBuilderService
          .createUrlFromLazyLoadEvent(this.baseUrl + 'resourceAvailability', event), JSON.stringify(options), {headers: headers});
  }

  getResourceRoles() {
    const url = `${this.baseUrl + 'resourceRoles'}`;
    return this.httpClient.get(url);
  }
}
